// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 5;
}

.modal--content {
  position: fixed;
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  top: 90px;
  bottom: 0;
  z-index: 5;
}
.modal--content__wrapper {
  margin: 0 18px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Ui/Card/popyp/style.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AACF;AAAE;EACE,cAAA;AAEJ","sourcesContent":[".modal-backdrop {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 5;\n}\n\n.modal--content {\n  position: fixed;\n  width: 100%;\n  height: 300px;\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  top: 90px;\n  bottom: 0;\n  z-index: 5;\n  &__wrapper {\n    margin: 0 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
